// ⚠️⚠️⚠️ **Disclaimer:** Please tailor this content to suit the specific needs of your business.
// If a penguin were to ask, "How do I order a pizza from the North Pole?" feel free to ponder that while crafting your FAQs!

import React from "react";
import { IconAccessible, IconChecklist, IconTypography, IconDeviceMobile, IconQuestionMark } from "@tabler/icons-react";
import { navigate } from "vike/client/router";
import { FAQAction } from "#root/database/types";

async function onSubmit(route: string) {
  const navigationPromise = navigate(route);
  await navigationPromise;
}

export const faq: readonly FAQAction[] = Object.freeze([
  {
    id: "1",
    label: "Why is accessibility important in web projects?",
    description:
      "Accessibility ensures that everyone, including people with disabilities, can use your website. It's a foundation of quality and inclusivity.",
    highlight: ["disabilities"],
    onClick: () => onSubmit("/faq"),
    leftSection: <IconAccessible size={24} stroke={1.5} />,
  },
  {
    id: "2",
    label: "What is Opquast and why should I care?",
    description:
      "Opquast is a universal checklist of web quality best practices, covering accessibility, performance, and user trust. It's a great guide for any digital team.",
    highlight: ["checklist"],
    onClick: () => onSubmit("/faq"),
    leftSection: <IconChecklist size={24} stroke={1.5} />,
  },
  {
    id: "3",
    label: "How can I test if my site is accessible?",
    description:
      "Use tools like Lighthouse, axe, or screen readers to evaluate contrast, navigation, focus states, and semantics.",
    highlight: ["Lighthouse"],
    onClick: () => onSubmit("/faq"),
    leftSection: <IconQuestionMark size={24} stroke={1.5} />,
  },
  {
    id: "4",
    label: "Do I need to support mobile accessibility?",
    description:
      "Yes! Accessibility isn't just for desktops. Touch targets, zoom, and responsive readability are all key on mobile devices.",
    highlight: ["readability"],
    onClick: () => onSubmit("/faq"),
    leftSection: <IconDeviceMobile size={24} stroke={1.5} />,
  },
  {
    id: "5",
    label: "Should I care about font sizes and color contrast?",
    description:
      "Absolutely. Good typography and contrast help all users—especially those with visual impairments—consume content with ease.",
    highlight: ["typography", "contrast"],
    onClick: () => onSubmit("/faq"),
    leftSection: <IconTypography size={24} stroke={1.5} />,
  },
]);
